<script lang="ts">
    import type { Curator } from '$lib/collectui/types';
    import { CURATOR_SELECT } from '$lib/collectui/selects';
    import { supabase } from '$lib/supabase';
    import { tick } from 'svelte';
    import AddCurator from './AddCurator.svelte';
    import CuratorCard from './CuratorCard.svelte';

    let curators: Curator[] = $state([]);

    supabase
        .from('collectui_curators')
        .select(CURATOR_SELECT)
        .then(({ data }) => {
            if (data) {
                curators = data;
            }
        });

    async function handleAdd(newCurator: Curator) {
        curators.push(newCurator);

        await tick();

        setTimeout(() => {
            const el = document.querySelector(
                `[data-username="${newCurator.username}"]`,
            );
            el?.scrollIntoView({ behavior: 'smooth' });
        }, 300);
    }

    async function handleDelete(curator: Curator) {
        const index = curators.findIndex((e) => e.id === curator.id);
        if (index !== -1) {
            curators.splice(index, 1);
        }
    }
</script>

<div class="flex flex-col h-screen overflow-hidden pb-10">
    <div class="flex justify-end p-4 border-b">
        <AddCurator onadd={handleAdd} />
    </div>
    <div class="flex-1 overflow-y-auto p-4">
        <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {#each curators as curator}
                <CuratorCard {curator} ondelete={() => handleDelete(curator)} />
            {/each}
        </div>
    </div>
</div>
